// ##############################################################

// #             GENEROVANÝ KÓD, NEMODIFIKOVAT!!!!              #

// #                  2019-01-25T10:29:09Z                      #

// ##############################################################

export function updateSpsTypDokument_C157E5(data) {
    if (data == null) {
        return data;
    }
    let result = {
        ...data,
        '@class': data['@class'] ? data['@class'] : 'SpsTypDokumentVO',
    };

    if (typeof data.vecnaSkupina !== "undefined") {
        result.vecnaSkupina = updateVecnaSkupina_48F444(data.vecnaSkupina);
    }

    return result;
}

export function updateMapSpsTypDokument_C157E5(data) {
    if (data == null) {
        return data;
    }
    const result = {};
    Object.keys(data).forEach(key => {
        result[key] = updateSpsTypDokument_C157E5(data[key]);
    });
    return result;
}

export function updateListSpsTypDokument_C157E5(data) {
    if (data == null) {
        return data;
    }
    return data.map(updateSpsTypDokument_C157E5);
}

export function updateDokument_7CD91D(data) {
    if (data == null) {
        return data;
    }

    if (!data["@class"]) {
        console.error("Objekt nemá definován typ třídy (atribut @class)", data);
        throw "Objekt nemá definován typ třídy (atribut @class)";
    }

    switch (data["@class"]) {
        case "ProfilDokumentVO":
            return updateProfilDokumentVO_94C8D9(data);
        case "DokumentVO":
            return updateDokumentVO_B829F1(data);
        default:
            console.error("Nepodporovaný typ třídy (atribut @class)", data["@class"], data);
            throw "Nepodporovaný typ třídy (atribut @class) '" + data["@class"] + "'";
    }
}

export function updateMapDokument_7CD91D(data) {
    if (data == null) {
        return data;
    }
    const result = {};
    Object.keys(data).forEach(key => {
        result[key] = updateDokument_7CD91D(data[key]);
    });
    return result;
}

export function updateListDokument_7CD91D(data) {
    if (data == null) {
        return data;
    }
    return data.map(updateDokument_7CD91D);
}

export function updatePracovnik_1DDB32(data) {
    if (data == null) {
        return data;
    }
    let result = {
        ...data,
        '@class': data['@class'] ? data['@class'] : 'PracovnikVO',
    };

    if (typeof data.organizacniJednotka !== "undefined") {
        result.organizacniJednotka = updateOrganizacniJednotka_81EB65(data.organizacniJednotka);
    }

    return result;
}

export function updateMapPracovnik_1DDB32(data) {
    if (data == null) {
        return data;
    }
    const result = {};
    Object.keys(data).forEach(key => {
        result[key] = updatePracovnik_1DDB32(data[key]);
    });
    return result;
}

export function updateListPracovnik_1DDB32(data) {
    if (data == null) {
        return data;
    }
    return data.map(updatePracovnik_1DDB32);
}

export function updateVyrizeni_73C4EB(data) {
    if (data == null) {
        return data;
    }
    let result = {
        ...data,
        '@class': data['@class'] ? data['@class'] : 'VyrizeniVO',
    };


    return result;
}

export function updateMapVyrizeni_73C4EB(data) {
    if (data == null) {
        return data;
    }
    const result = {};
    Object.keys(data).forEach(key => {
        result[key] = updateVyrizeni_73C4EB(data[key]);
    });
    return result;
}

export function updateListVyrizeni_73C4EB(data) {
    if (data == null) {
        return data;
    }
    return data.map(updateVyrizeni_73C4EB);
}

export function updateProfilDokumentVO_94C8D9(data) {
    if (data == null) {
        return data;
    }
    let result = {
        ...data,
    };

    if (typeof data.spis !== "undefined") {
        result.spis = updateSpis_CA4FE8(data.spis);
    }
    if (typeof data.doruceni !== "undefined") {
        result.doruceni = updateDoruceni_EE46B0(data.doruceni);
    }
    if (typeof data.vecnaSkupina !== "undefined") {
        result.vecnaSkupina = updateVecnaSkupina_48F444(data.vecnaSkupina);
    }
    if (typeof data.spsTypDokument !== "undefined") {
        result.spsTypDokument = updateSpsTypDokument_C157E5(data.spsTypDokument);
    }
    if (typeof data.zpusobVypraveni !== "undefined") {
        result.zpusobVypraveni = updateZpusobVypraveni_341ABB(data.zpusobVypraveni);
    }
    if (typeof data.typDokument !== "undefined") {
        result.typDokument = updateTypDokument_F4181F(data.typDokument);
    }
    if (typeof data.zpracovatel !== "undefined") {
        result.zpracovatel = updatePracovnik_1DDB32(data.zpracovatel);
    }
    if (typeof data.hlavniSoubor !== "undefined") {
        result.hlavniSoubor = updateDokumentSoubor_8B5FF4(data.hlavniSoubor);
    }
    if (typeof data.souboryDokumentu !== "undefined") {
        result.souboryDokumentu = updateListDokumentSoubor_8B5FF4(data.souboryDokumentu);
    }

    return result;
}

export function updateMapProfilDokumentVO_94C8D9(data) {
    if (data == null) {
        return data;
    }
    const result = {};
    Object.keys(data).forEach(key => {
        result[key] = updateProfilDokumentVO_94C8D9(data[key]);
    });
    return result;
}

export function updateListProfilDokumentVO_94C8D9(data) {
    if (data == null) {
        return data;
    }
    return data.map(updateProfilDokumentVO_94C8D9);
}

export function updateTypDokument_F4181F(data) {
    if (data == null) {
        return data;
    }
    let result = {
        ...data,
        '@class': data['@class'] ? data['@class'] : 'TypDokumentVO',
    };


    return result;
}

export function updateMapTypDokument_F4181F(data) {
    if (data == null) {
        return data;
    }
    const result = {};
    Object.keys(data).forEach(key => {
        result[key] = updateTypDokument_F4181F(data[key]);
    });
    return result;
}

export function updateListTypDokument_F4181F(data) {
    if (data == null) {
        return data;
    }
    return data.map(updateTypDokument_F4181F);
}

export function updateVypraveniVO_AAA110(data) {
    if (data == null) {
        return data;
    }
    let result = {
        ...data,
    };

    if (typeof data.adresat !== "undefined") {
        result.adresat = updateSubjekt_62E626(data.adresat);
    }
    if (typeof data.adresa !== "undefined") {
        result.adresa = updateAdresa_CEF31D(data.adresa);
    }
    if (typeof data.zpusobVypraveni !== "undefined") {
        result.zpusobVypraveni = updateZpusobVypraveni_341ABB(data.zpusobVypraveni);
    }

    return result;
}

export function updateMapVypraveniVO_AAA110(data) {
    if (data == null) {
        return data;
    }
    const result = {};
    Object.keys(data).forEach(key => {
        result[key] = updateVypraveniVO_AAA110(data[key]);
    });
    return result;
}

export function updateListVypraveniVO_AAA110(data) {
    if (data == null) {
        return data;
    }
    return data.map(updateVypraveniVO_AAA110);
}

export function updateFyzickaOsobaPodVO_762C50(data) {
    if (data == null) {
        return data;
    }
    let result = {
        ...data,
    };

    if (typeof data.fyzickaOsoba !== "undefined") {
        result.fyzickaOsoba = updateFyzickaOsoba_0D0EFC(data.fyzickaOsoba);
    }
    if (typeof data.pravniForma !== "undefined") {
        result.pravniForma = updatePravniForma_6646A5(data.pravniForma);
    }
    if (typeof data.stavZr !== "undefined") {
        result.stavZr = updateSubjektStavZr_FDF5A9(data.stavZr);
    }
    if (typeof data.adresaTrv !== "undefined") {
        result.adresaTrv = updateAdresa_CEF31D(data.adresaTrv);
    }
    if (typeof data.adresaDoruc !== "undefined") {
        result.adresaDoruc = updateAdresa_CEF31D(data.adresaDoruc);
    }
    if (typeof data.email !== "undefined") {
        result.email = updateKontakt_39A327(data.email);
    }
    if (typeof data.telefon !== "undefined") {
        result.telefon = updateKontakt_39A327(data.telefon);
    }
    if (typeof data.datovaSchranka !== "undefined") {
        result.datovaSchranka = updateKontakt_39A327(data.datovaSchranka);
    }
    if (typeof data.zastupce !== "undefined") {
        result.zastupce = updateSubjekt_62E626(data.zastupce);
    }

    return result;
}

export function updateMapFyzickaOsobaPodVO_762C50(data) {
    if (data == null) {
        return data;
    }
    const result = {};
    Object.keys(data).forEach(key => {
        result[key] = updateFyzickaOsobaPodVO_762C50(data[key]);
    });
    return result;
}

export function updateListFyzickaOsobaPodVO_762C50(data) {
    if (data == null) {
        return data;
    }
    return data.map(updateFyzickaOsobaPodVO_762C50);
}

export function updateDoruceniVO_3A7610(data) {
    if (data == null) {
        return data;
    }
    let result = {
        ...data,
    };

    if (typeof data.odesilatel !== "undefined") {
        result.odesilatel = updateSubjekt_62E626(data.odesilatel);
    }

    return result;
}

export function updateMapDoruceniVO_3A7610(data) {
    if (data == null) {
        return data;
    }
    const result = {};
    Object.keys(data).forEach(key => {
        result[key] = updateDoruceniVO_3A7610(data[key]);
    });
    return result;
}

export function updateListDoruceniVO_3A7610(data) {
    if (data == null) {
        return data;
    }
    return data.map(updateDoruceniVO_3A7610);
}

export function updateDoklad_0FE11E(data) {
    if (data == null) {
        return data;
    }
    let result = {
        ...data,
        '@class': data['@class'] ? data['@class'] : 'DokladVO',
    };


    return result;
}

export function updateMapDoklad_0FE11E(data) {
    if (data == null) {
        return data;
    }
    const result = {};
    Object.keys(data).forEach(key => {
        result[key] = updateDoklad_0FE11E(data[key]);
    });
    return result;
}

export function updateListDoklad_0FE11E(data) {
    if (data == null) {
        return data;
    }
    return data.map(updateDoklad_0FE11E);
}

export function updateProfilDokument_F258CD(data) {
    if (data == null) {
        return data;
    }
    let result = {
        ...data,
        '@class': data['@class'] ? data['@class'] : 'ProfilDokumentVO',
    };

    if (typeof data.spis !== "undefined") {
        result.spis = updateSpis_CA4FE8(data.spis);
    }
    if (typeof data.doruceni !== "undefined") {
        result.doruceni = updateDoruceni_EE46B0(data.doruceni);
    }
    if (typeof data.vecnaSkupina !== "undefined") {
        result.vecnaSkupina = updateVecnaSkupina_48F444(data.vecnaSkupina);
    }
    if (typeof data.spsTypDokument !== "undefined") {
        result.spsTypDokument = updateSpsTypDokument_C157E5(data.spsTypDokument);
    }
    if (typeof data.zpusobVypraveni !== "undefined") {
        result.zpusobVypraveni = updateZpusobVypraveni_341ABB(data.zpusobVypraveni);
    }

    return result;
}

export function updateMapProfilDokument_F258CD(data) {
    if (data == null) {
        return data;
    }
    const result = {};
    Object.keys(data).forEach(key => {
        result[key] = updateProfilDokument_F258CD(data[key]);
    });
    return result;
}

export function updateListProfilDokument_F258CD(data) {
    if (data == null) {
        return data;
    }
    return data.map(updateProfilDokument_F258CD);
}

export function updateObsahSpisu_15977C(data) {
    if (data == null) {
        return data;
    }
    let result = {
        ...data,
        '@class': data['@class'] ? data['@class'] : 'ObsahSpisuVO',
    };

    if (typeof data.dokumenty !== "undefined") {
        result.dokumenty = updateListProfilDokument_F258CD(data.dokumenty);
    }

    return result;
}

export function updateMapObsahSpisu_15977C(data) {
    if (data == null) {
        return data;
    }
    const result = {};
    Object.keys(data).forEach(key => {
        result[key] = updateObsahSpisu_15977C(data[key]);
    });
    return result;
}

export function updateListObsahSpisu_15977C(data) {
    if (data == null) {
        return data;
    }
    return data.map(updateObsahSpisu_15977C);
}

export function updateKontaktVO_081B44(data) {
    if (data == null) {
        return data;
    }
    let result = {
        ...data,
    };

    if (typeof data.adresa !== "undefined") {
        result.adresa = updateAdresa_CEF31D(data.adresa);
    }

    return result;
}

export function updateMapKontaktVO_081B44(data) {
    if (data == null) {
        return data;
    }
    const result = {};
    Object.keys(data).forEach(key => {
        result[key] = updateKontaktVO_081B44(data[key]);
    });
    return result;
}

export function updateListKontaktVO_081B44(data) {
    if (data == null) {
        return data;
    }
    return data.map(updateKontaktVO_081B44);
}

export function updateFyzickaOsobaVO_687919(data) {
    if (data == null) {
        return data;
    }
    let result = {
        ...data,
    };

    if (typeof data.identifikacniDoklad !== "undefined") {
        result.identifikacniDoklad = updateDoklad_0FE11E(data.identifikacniDoklad);
    }
    if (typeof data.cestovniDoklad !== "undefined") {
        result.cestovniDoklad = updateDoklad_0FE11E(data.cestovniDoklad);
    }
    if (typeof data.stavZr !== "undefined") {
        result.stavZr = updateSubjektStavZr_FDF5A9(data.stavZr);
    }
    if (typeof data.adresaTrv !== "undefined") {
        result.adresaTrv = updateAdresa_CEF31D(data.adresaTrv);
    }
    if (typeof data.adresaDoruc !== "undefined") {
        result.adresaDoruc = updateAdresa_CEF31D(data.adresaDoruc);
    }
    if (typeof data.email !== "undefined") {
        result.email = updateKontakt_39A327(data.email);
    }
    if (typeof data.telefon !== "undefined") {
        result.telefon = updateKontakt_39A327(data.telefon);
    }
    if (typeof data.datovaSchranka !== "undefined") {
        result.datovaSchranka = updateKontakt_39A327(data.datovaSchranka);
    }
    if (typeof data.zastupce !== "undefined") {
        result.zastupce = updateSubjekt_62E626(data.zastupce);
    }

    return result;
}

export function updateMapFyzickaOsobaVO_687919(data) {
    if (data == null) {
        return data;
    }
    const result = {};
    Object.keys(data).forEach(key => {
        result[key] = updateFyzickaOsobaVO_687919(data[key]);
    });
    return result;
}

export function updateListFyzickaOsobaVO_687919(data) {
    if (data == null) {
        return data;
    }
    return data.map(updateFyzickaOsobaVO_687919);
}

export function updatePravniForma_6646A5(data) {
    if (data == null) {
        return data;
    }
    let result = {
        ...data,
        '@class': data['@class'] ? data['@class'] : 'PravniFormaVO',
    };


    return result;
}

export function updateMapPravniForma_6646A5(data) {
    if (data == null) {
        return data;
    }
    const result = {};
    Object.keys(data).forEach(key => {
        result[key] = updatePravniForma_6646A5(data[key]);
    });
    return result;
}

export function updateListPravniForma_6646A5(data) {
    if (data == null) {
        return data;
    }
    return data.map(updatePravniForma_6646A5);
}

export function updateSubjekt_62E626(data) {
    if (data == null) {
        return data;
    }

    if (!data["@class"]) {
        console.error("Objekt nemá definován typ třídy (atribut @class)", data);
        throw "Objekt nemá definován typ třídy (atribut @class)";
    }

    switch (data["@class"]) {
        case "FyzickaOsobaVO":
            return updateFyzickaOsobaVO_687919(data);
        case "PravnickaOsobaVO":
            return updatePravnickaOsobaVO_CE3CCC(data);
        case "FyzickaOsobaPodVO":
            return updateFyzickaOsobaPodVO_762C50(data);
        default:
            console.error("Nepodporovaný typ třídy (atribut @class)", data["@class"], data);
            throw "Nepodporovaný typ třídy (atribut @class) '" + data["@class"] + "'";
    }
}

export function updateMapSubjekt_62E626(data) {
    if (data == null) {
        return data;
    }
    const result = {};
    Object.keys(data).forEach(key => {
        result[key] = updateSubjekt_62E626(data[key]);
    });
    return result;
}

export function updateListSubjekt_62E626(data) {
    if (data == null) {
        return data;
    }
    return data.map(updateSubjekt_62E626);
}

export function updateSpsTypDokumentVO_C3A54E(data) {
    if (data == null) {
        return data;
    }
    let result = {
        ...data,
    };

    if (typeof data.vecnaSkupina !== "undefined") {
        result.vecnaSkupina = updateVecnaSkupina_48F444(data.vecnaSkupina);
    }

    return result;
}

export function updateMapSpsTypDokumentVO_C3A54E(data) {
    if (data == null) {
        return data;
    }
    const result = {};
    Object.keys(data).forEach(key => {
        result[key] = updateSpsTypDokumentVO_C3A54E(data[key]);
    });
    return result;
}

export function updateListSpsTypDokumentVO_C3A54E(data) {
    if (data == null) {
        return data;
    }
    return data.map(updateSpsTypDokumentVO_C3A54E);
}

export function updateDoruceni_EE46B0(data) {
    if (data == null) {
        return data;
    }
    let result = {
        ...data,
        '@class': data['@class'] ? data['@class'] : 'DoruceniVO',
    };

    if (typeof data.odesilatel !== "undefined") {
        result.odesilatel = updateSubjekt_62E626(data.odesilatel);
    }

    return result;
}

export function updateMapDoruceni_EE46B0(data) {
    if (data == null) {
        return data;
    }
    const result = {};
    Object.keys(data).forEach(key => {
        result[key] = updateDoruceni_EE46B0(data[key]);
    });
    return result;
}

export function updateListDoruceni_EE46B0(data) {
    if (data == null) {
        return data;
    }
    return data.map(updateDoruceni_EE46B0);
}

export function updateDokumentSoubor_8B5FF4(data) {
    if (data == null) {
        return data;
    }

    if (!data["@class"]) {
        console.error("Objekt nemá definován typ třídy (atribut @class)", data);
        throw "Objekt nemá definován typ třídy (atribut @class)";
    }

    switch (data["@class"]) {
        case "PrilohaVO":
            return data;
        case "DokumentSouborVO":
            return data;
        default:
            console.error("Nepodporovaný typ třídy (atribut @class)", data["@class"], data);
            throw "Nepodporovaný typ třídy (atribut @class) '" + data["@class"] + "'";
    }
}

export function updateMapDokumentSoubor_8B5FF4(data) {
    if (data == null) {
        return data;
    }
    const result = {};
    Object.keys(data).forEach(key => {
        result[key] = updateDokumentSoubor_8B5FF4(data[key]);
    });
    return result;
}

export function updateListDokumentSoubor_8B5FF4(data) {
    if (data == null) {
        return data;
    }
    return data.map(updateDokumentSoubor_8B5FF4);
}

export function updateSubjektStavZr_FDF5A9(data) {
    if (data == null) {
        return data;
    }
    let result = {
        ...data,
        '@class': data['@class'] ? data['@class'] : 'SubjektStavZrVO',
    };


    return result;
}

export function updateMapSubjektStavZr_FDF5A9(data) {
    if (data == null) {
        return data;
    }
    const result = {};
    Object.keys(data).forEach(key => {
        result[key] = updateSubjektStavZr_FDF5A9(data[key]);
    });
    return result;
}

export function updateListSubjektStavZr_FDF5A9(data) {
    if (data == null) {
        return data;
    }
    return data.map(updateSubjektStavZr_FDF5A9);
}

export function updateAdresa_CEF31D(data) {
    if (data == null) {
        return data;
    }
    let result = {
        ...data,
        '@class': data['@class'] ? data['@class'] : 'AdresaVO',
    };


    return result;
}

export function updateMapAdresa_CEF31D(data) {
    if (data == null) {
        return data;
    }
    const result = {};
    Object.keys(data).forEach(key => {
        result[key] = updateAdresa_CEF31D(data[key]);
    });
    return result;
}

export function updateListAdresa_CEF31D(data) {
    if (data == null) {
        return data;
    }
    return data.map(updateAdresa_CEF31D);
}

export function updateVyveseniVO_9A1382(data) {
    if (data == null) {
        return data;
    }
    let result = {
        ...data,
    };

    if (typeof data.odesilatel !== "undefined") {
        result.odesilatel = updateSubjekt_62E626(data.odesilatel);
    }
    if (typeof data.kategorieUredniDesky !== "undefined") {
        result.kategorieUredniDesky = updateKategorieUredniDesky_36208D(data.kategorieUredniDesky);
    }

    return result;
}

export function updateMapVyveseniVO_9A1382(data) {
    if (data == null) {
        return data;
    }
    const result = {};
    Object.keys(data).forEach(key => {
        result[key] = updateVyveseniVO_9A1382(data[key]);
    });
    return result;
}

export function updateListVyveseniVO_9A1382(data) {
    if (data == null) {
        return data;
    }
    return data.map(updateVyveseniVO_9A1382);
}

export function updateObsahSpisuVO_FA815A(data) {
    if (data == null) {
        return data;
    }
    let result = {
        ...data,
    };

    if (typeof data.dokumenty !== "undefined") {
        result.dokumenty = updateListProfilDokument_F258CD(data.dokumenty);
    }
    if (typeof data.zpracovatel !== "undefined") {
        result.zpracovatel = updatePracovnik_1DDB32(data.zpracovatel);
    }
    if (typeof data.vecnaSkupina !== "undefined") {
        result.vecnaSkupina = updateVecnaSkupina_48F444(data.vecnaSkupina);
    }

    return result;
}

export function updateMapObsahSpisuVO_FA815A(data) {
    if (data == null) {
        return data;
    }
    const result = {};
    Object.keys(data).forEach(key => {
        result[key] = updateObsahSpisuVO_FA815A(data[key]);
    });
    return result;
}

export function updateListObsahSpisuVO_FA815A(data) {
    if (data == null) {
        return data;
    }
    return data.map(updateObsahSpisuVO_FA815A);
}

export function updateOrganizacniJednotka_81EB65(data) {
    if (data == null) {
        return data;
    }
    let result = {
        ...data,
        '@class': data['@class'] ? data['@class'] : 'OrganizacniJednotkaVO',
    };


    return result;
}

export function updateMapOrganizacniJednotka_81EB65(data) {
    if (data == null) {
        return data;
    }
    const result = {};
    Object.keys(data).forEach(key => {
        result[key] = updateOrganizacniJednotka_81EB65(data[key]);
    });
    return result;
}

export function updateListOrganizacniJednotka_81EB65(data) {
    if (data == null) {
        return data;
    }
    return data.map(updateOrganizacniJednotka_81EB65);
}

export function updateFyzickaOsoba_0D0EFC(data) {
    if (data == null) {
        return data;
    }
    let result = {
        ...data,
        '@class': data['@class'] ? data['@class'] : 'FyzickaOsobaVO',
    };

    if (typeof data.identifikacniDoklad !== "undefined") {
        result.identifikacniDoklad = updateDoklad_0FE11E(data.identifikacniDoklad);
    }
    if (typeof data.cestovniDoklad !== "undefined") {
        result.cestovniDoklad = updateDoklad_0FE11E(data.cestovniDoklad);
    }

    return result;
}

export function updateMapFyzickaOsoba_0D0EFC(data) {
    if (data == null) {
        return data;
    }
    const result = {};
    Object.keys(data).forEach(key => {
        result[key] = updateFyzickaOsoba_0D0EFC(data[key]);
    });
    return result;
}

export function updateListFyzickaOsoba_0D0EFC(data) {
    if (data == null) {
        return data;
    }
    return data.map(updateFyzickaOsoba_0D0EFC);
}

export function updateKontakt_39A327(data) {
    if (data == null) {
        return data;
    }
    let result = {
        ...data,
        '@class': data['@class'] ? data['@class'] : 'KontaktVO',
    };

    if (typeof data.adresa !== "undefined") {
        result.adresa = updateAdresa_CEF31D(data.adresa);
    }

    return result;
}

export function updateMapKontakt_39A327(data) {
    if (data == null) {
        return data;
    }
    const result = {};
    Object.keys(data).forEach(key => {
        result[key] = updateKontakt_39A327(data[key]);
    });
    return result;
}

export function updateListKontakt_39A327(data) {
    if (data == null) {
        return data;
    }
    return data.map(updateKontakt_39A327);
}

export function updateKategorieUredniDesky_36208D(data) {
    if (data == null) {
        return data;
    }
    let result = {
        ...data,
        '@class': data['@class'] ? data['@class'] : 'KategorieUredniDeskyVO',
    };


    return result;
}

export function updateMapKategorieUredniDesky_36208D(data) {
    if (data == null) {
        return data;
    }
    const result = {};
    Object.keys(data).forEach(key => {
        result[key] = updateKategorieUredniDesky_36208D(data[key]);
    });
    return result;
}

export function updateListKategorieUredniDesky_36208D(data) {
    if (data == null) {
        return data;
    }
    return data.map(updateKategorieUredniDesky_36208D);
}

export function updateZpusobVypraveni_341ABB(data) {
    if (data == null) {
        return data;
    }
    let result = {
        ...data,
        '@class': data['@class'] ? data['@class'] : 'ZpusobVypraveniVO',
    };


    return result;
}

export function updateMapZpusobVypraveni_341ABB(data) {
    if (data == null) {
        return data;
    }
    const result = {};
    Object.keys(data).forEach(key => {
        result[key] = updateZpusobVypraveni_341ABB(data[key]);
    });
    return result;
}

export function updateListZpusobVypraveni_341ABB(data) {
    if (data == null) {
        return data;
    }
    return data.map(updateZpusobVypraveni_341ABB);
}

export function updatePravnickaOsobaVO_CE3CCC(data) {
    if (data == null) {
        return data;
    }
    let result = {
        ...data,
    };

    if (typeof data.pravniForma !== "undefined") {
        result.pravniForma = updatePravniForma_6646A5(data.pravniForma);
    }
    if (typeof data.stavZr !== "undefined") {
        result.stavZr = updateSubjektStavZr_FDF5A9(data.stavZr);
    }
    if (typeof data.adresaTrv !== "undefined") {
        result.adresaTrv = updateAdresa_CEF31D(data.adresaTrv);
    }
    if (typeof data.adresaDoruc !== "undefined") {
        result.adresaDoruc = updateAdresa_CEF31D(data.adresaDoruc);
    }
    if (typeof data.email !== "undefined") {
        result.email = updateKontakt_39A327(data.email);
    }
    if (typeof data.telefon !== "undefined") {
        result.telefon = updateKontakt_39A327(data.telefon);
    }
    if (typeof data.datovaSchranka !== "undefined") {
        result.datovaSchranka = updateKontakt_39A327(data.datovaSchranka);
    }
    if (typeof data.zastupce !== "undefined") {
        result.zastupce = updateSubjekt_62E626(data.zastupce);
    }

    return result;
}

export function updateMapPravnickaOsobaVO_CE3CCC(data) {
    if (data == null) {
        return data;
    }
    const result = {};
    Object.keys(data).forEach(key => {
        result[key] = updatePravnickaOsobaVO_CE3CCC(data[key]);
    });
    return result;
}

export function updateListPravnickaOsobaVO_CE3CCC(data) {
    if (data == null) {
        return data;
    }
    return data.map(updatePravnickaOsobaVO_CE3CCC);
}

export function updateDokumentVO_B829F1(data) {
    if (data == null) {
        return data;
    }
    let result = {
        ...data,
    };

    if (typeof data.typDokument !== "undefined") {
        result.typDokument = updateTypDokument_F4181F(data.typDokument);
    }
    if (typeof data.zpracovatel !== "undefined") {
        result.zpracovatel = updatePracovnik_1DDB32(data.zpracovatel);
    }
    if (typeof data.hlavniSoubor !== "undefined") {
        result.hlavniSoubor = updateDokumentSoubor_8B5FF4(data.hlavniSoubor);
    }
    if (typeof data.souboryDokumentu !== "undefined") {
        result.souboryDokumentu = updateListDokumentSoubor_8B5FF4(data.souboryDokumentu);
    }

    return result;
}

export function updateMapDokumentVO_B829F1(data) {
    if (data == null) {
        return data;
    }
    const result = {};
    Object.keys(data).forEach(key => {
        result[key] = updateDokumentVO_B829F1(data[key]);
    });
    return result;
}

export function updateListDokumentVO_B829F1(data) {
    if (data == null) {
        return data;
    }
    return data.map(updateDokumentVO_B829F1);
}

export function updateVecnaSkupina_48F444(data) {
    if (data == null) {
        return data;
    }
    let result = {
        ...data,
        '@class': data['@class'] ? data['@class'] : 'VecnaSkupinaVO',
    };


    return result;
}

export function updateMapVecnaSkupina_48F444(data) {
    if (data == null) {
        return data;
    }
    const result = {};
    Object.keys(data).forEach(key => {
        result[key] = updateVecnaSkupina_48F444(data[key]);
    });
    return result;
}

export function updateListVecnaSkupina_48F444(data) {
    if (data == null) {
        return data;
    }
    return data.map(updateVecnaSkupina_48F444);
}

export function updateSpis_CA4FE8(data) {
    if (data == null) {
        return data;
    }
    let result = {
        ...data,
        '@class': data['@class'] ? data['@class'] : 'SpisVO',
    };

    if (typeof data.zpracovatel !== "undefined") {
        result.zpracovatel = updatePracovnik_1DDB32(data.zpracovatel);
    }
    if (typeof data.vecnaSkupina !== "undefined") {
        result.vecnaSkupina = updateVecnaSkupina_48F444(data.vecnaSkupina);
    }

    return result;
}

export function updateMapSpis_CA4FE8(data) {
    if (data == null) {
        return data;
    }
    const result = {};
    Object.keys(data).forEach(key => {
        result[key] = updateSpis_CA4FE8(data[key]);
    });
    return result;
}

export function updateListSpis_CA4FE8(data) {
    if (data == null) {
        return data;
    }
    return data.map(updateSpis_CA4FE8);
}

export function updatePracovnikVO_816D16(data) {
    if (data == null) {
        return data;
    }
    let result = {
        ...data,
    };

    if (typeof data.organizacniJednotka !== "undefined") {
        result.organizacniJednotka = updateOrganizacniJednotka_81EB65(data.organizacniJednotka);
    }

    return result;
}

export function updateMapPracovnikVO_816D16(data) {
    if (data == null) {
        return data;
    }
    const result = {};
    Object.keys(data).forEach(key => {
        result[key] = updatePracovnikVO_816D16(data[key]);
    });
    return result;
}

export function updateListPracovnikVO_816D16(data) {
    if (data == null) {
        return data;
    }
    return data.map(updatePracovnikVO_816D16);
}

export function updateVypraveni_B72A36(data) {
    if (data == null) {
        return data;
    }
    let result = {
        ...data,
        '@class': data['@class'] ? data['@class'] : 'VypraveniVO',
    };

    if (typeof data.adresat !== "undefined") {
        result.adresat = updateSubjekt_62E626(data.adresat);
    }
    if (typeof data.adresa !== "undefined") {
        result.adresa = updateAdresa_CEF31D(data.adresa);
    }
    if (typeof data.zpusobVypraveni !== "undefined") {
        result.zpusobVypraveni = updateZpusobVypraveni_341ABB(data.zpusobVypraveni);
    }

    return result;
}

export function updateMapVypraveni_B72A36(data) {
    if (data == null) {
        return data;
    }
    const result = {};
    Object.keys(data).forEach(key => {
        result[key] = updateVypraveni_B72A36(data[key]);
    });
    return result;
}

export function updateListVypraveni_B72A36(data) {
    if (data == null) {
        return data;
    }
    return data.map(updateVypraveni_B72A36);
}

export function updateDokumentFilter_EBB44A(data) {
    if (data == null) {
        return data;
    }
    let result = {
        ...data,
        '@class': data['@class'] ? data['@class'] : 'DokumentFilterVO',
    };


    return result;
}

export function updateMapDokumentFilter_EBB44A(data) {
    if (data == null) {
        return data;
    }
    const result = {};
    Object.keys(data).forEach(key => {
        result[key] = updateDokumentFilter_EBB44A(data[key]);
    });
    return result;
}

export function updateListDokumentFilter_EBB44A(data) {
    if (data == null) {
        return data;
    }
    return data.map(updateDokumentFilter_EBB44A);
}

export function updateSpisVO_0ECD1A(data) {
    if (data == null) {
        return data;
    }
    let result = {
        ...data,
    };

    if (typeof data.zpracovatel !== "undefined") {
        result.zpracovatel = updatePracovnik_1DDB32(data.zpracovatel);
    }
    if (typeof data.vecnaSkupina !== "undefined") {
        result.vecnaSkupina = updateVecnaSkupina_48F444(data.vecnaSkupina);
    }

    return result;
}

export function updateMapSpisVO_0ECD1A(data) {
    if (data == null) {
        return data;
    }
    const result = {};
    Object.keys(data).forEach(key => {
        result[key] = updateSpisVO_0ECD1A(data[key]);
    });
    return result;
}

export function updateListSpisVO_0ECD1A(data) {
    if (data == null) {
        return data;
    }
    return data.map(updateSpisVO_0ECD1A);
}

export function updateVyveseni_9DCD37(data) {
    if (data == null) {
        return data;
    }
    let result = {
        ...data,
        '@class': data['@class'] ? data['@class'] : 'VyveseniVO',
    };

    if (typeof data.odesilatel !== "undefined") {
        result.odesilatel = updateSubjekt_62E626(data.odesilatel);
    }
    if (typeof data.kategorieUredniDesky !== "undefined") {
        result.kategorieUredniDesky = updateKategorieUredniDesky_36208D(data.kategorieUredniDesky);
    }

    return result;
}

export function updateMapVyveseni_9DCD37(data) {
    if (data == null) {
        return data;
    }
    const result = {};
    Object.keys(data).forEach(key => {
        result[key] = updateVyveseni_9DCD37(data[key]);
    });
    return result;
}

export function updateListVyveseni_9DCD37(data) {
    if (data == null) {
        return data;
    }
    return data.map(updateVyveseni_9DCD37);
}
